module.exports = __webpack_public_path__ + "static/media/RJC_2023_v2.c6e03218.png";